/* TruBeam welcome-25 auto-discount price display */
(function(){
  var KEY='tb_welcome25', TTL=14*24*60*60*1000, PCT=0.25;
  function param(n){try{return new URLSearchParams(location.search).get(n);}catch(e){return null;}}
  function setFlag(){try{localStorage.setItem(KEY,String(Date.now()+TTL));}catch(e){}}
  function active(){
    if(param('tbw')==='1'){setFlag();return true;}
    try{var v=localStorage.getItem(KEY);if(v&&parseInt(v,10)>Date.now())return true;}catch(e){}
    return false;
  }
  if(!active())return;
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    var buy=document.querySelector('.tbp-buy');
    if(!buy)return;
    var root=buy.closest('[id^="tbp-"]')||buy;
    function money(c){return '$'+(c/100).toFixed(2);}
    function parse(s){if(!s)return 0;var m=(''+s).replace(/[^0-9.]/g,'');return m?Math.round(parseFloat(m)*100):0;}
    function oneTime(){var m=root.querySelector('.tbp-pt input[value="member"]');return !(m&&m.checked&&!m.disabled);}
    if(!root.querySelector('.tbw-banner')){
      var b=document.createElement('div');
      b.className='tbw-banner';
      b.innerHTML='<span aria-hidden="true">🎁</span> Your <b>25% welcome discount</b> is applied to one-time orders — you’ll see it at checkout.';
      var anchor=root.querySelector('.tbp-stock');
      if(anchor&&anchor.parentNode){anchor.parentNode.insertBefore(b,anchor.nextSibling);}else{buy.insertBefore(b,buy.firstChild);}
    }
    function apply(){
      if(!active())return;
      var one=oneTime();
      root.querySelectorAll('.tbp-tier').forEach(function(lbl){
        var inp=lbl.querySelector('input'), amt=lbl.querySelector('.tbp-amt'), was=lbl.querySelector('.tbp-was'), sv=lbl.querySelector('.tbp-save');
        if(one&&inp&&inp.dataset.total){
          var base=parse(inp.dataset.total), disc=Math.round(base*(1-PCT));
          if(amt){amt.textContent=money(disc);amt.classList.add('tbw-on');}
          if(was){was.textContent=money(base);was.style.display='';was.classList.add('tbw-on-was');}
          if(sv){sv.textContent='Save 25%';sv.style.display='';}
        }else{
          if(amt)amt.classList.remove('tbw-on');
          if(was)was.classList.remove('tbw-on-was');
        }
      });
      var c=root.querySelector('.tbp-tier input:checked');
      var tot=root.querySelector('[id^="tbtot-"]'), sav=root.querySelector('[id^="tbsav-"]');
      if(one&&c&&c.dataset.total&&tot){var base=parse(c.dataset.total);tot.textContent=money(Math.round(base*(1-PCT)));if(sav)sav.textContent=' · Save 25%';}
    }
    root.querySelectorAll('.tbp-tier input, .tbp-pt input').forEach(function(i){i.addEventListener('change',function(){setTimeout(apply,0);});});
    setTimeout(apply,0);
  });
})();
